<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Many people earned my gratitude for helping with this project. Among them were sports media representatives Steve Fenk of Oregon State University, Greg Walker of the University of Oregon and Mike Lund of Portland State University who tracked down many of the picture images that appear in the book. I also give thanks to <i>Oregonian</i> photographers Brent Wojahn and Thomas Boyd for the use of their photos. Drew Vattiat of the <i>Oregonian</i> deserves kudos, too, for patiently digging through the newspaper’s archives to find me photos from long ago. Roger Jensen, Rob Griffin, Tom Treick and Mike Shields were other contributing photographers.</p>
<p class="indent">The Portland Trail Blazers, through retired historian Chuck Charnquist, helped immensely by providing photos from the club’s archives. I also offer thanks to the National Greyhound Racing Association for its help, to Mac Wilkins who provided photos from his personal collection and to Wayne Thompson and Nick Bertram for some editing suggestions. In addition, Aubrie Koenig, my commissioning editor, was top notch with her encouragement.</p>
<p class="indent">Lastly, I express special appreciation to my daughter, Nan Hammerschmidt, for her line drawing and to my grandson, Jean-Paul Wallis, who used his computer savvy to help me survive the challenge of formatting and delivering the manuscript.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?00b83f5f